/*
  TRWS color-filtered gallery (2026-11-03)

  The server renders only the selected color's images (snippets/product-media-gallery.liquid).
  Dawn's default updateMedia only syncs the main viewer, never the thumbnail strip, so on a
  color change we swap in the whole freshly rendered gallery instead. Size changes within the
  same color leave the gallery alone so the shopper keeps the angle they were looking at.
*/
(() => {
  if (window.__trwsColorGalleryPatched) return;

  const patch = (ProductInfo) => {
    if (!ProductInfo || window.__trwsColorGalleryPatched) return;
    window.__trwsColorGalleryPatched = true;

    const originalUpdateMedia = ProductInfo.prototype.updateMedia;

    ProductInfo.prototype.updateMedia = function (html, variantFeaturedMediaId) {
      const current = this.querySelector('media-gallery');
      const next = html.querySelector('media-gallery');
      const filtered =
        current && next && (current.dataset.trwsFilter === 'true' || next.dataset.trwsFilter === 'true');

      if (!filtered) return originalUpdateMedia.call(this, html, variantFeaturedMediaId);

      if (current.dataset.trwsColor !== next.dataset.trwsColor) {
        (this.preProcessHtmlCallbacks || []).forEach((callback) => callback(next));
        current.replaceWith(next);

        const modalContent = this.productModal?.querySelector('.product-media-modal__content');
        const newModalContent = html.querySelector('product-modal .product-media-modal__content');
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
        return;
      }

      // Same color, different size: keep the current view.
      if (variantFeaturedMediaId) {
        const target = `${this.dataset.section}-${variantFeaturedMediaId}`;
        if (current.querySelector(`[data-media-id="${target}"].is-active`)) return;
      }
    };
  };

  const existing = customElements.get('product-info');
  if (existing) {
    patch(existing);
  } else {
    customElements.whenDefined('product-info').then(() => patch(customElements.get('product-info')));
  }
})();
